export default {"src":"https://gfiber.com/support/_next/static/media/article-tool-tip.39c70604.svg","height":20,"width":16,"blurWidth":0,"blurHeight":0};